import { generateHTML, type JSONContent } from "@tiptap/core";
import { MarkdownManager } from "@tiptap/markdown";
import { editorExtensions, normalizeTextColor } from "../components/block-editor/editor-extensions";

// One codec for string-backed documents/reports and their read-only viewers.
const markdown = new MarkdownManager({ extensions: editorExtensions, markedOptions: { breaks: true } });

export { normalizeTextColor } from "../components/block-editor/editor-extensions";

export function textToDocument(text: string): JSONContent {
  const doc = markdown.parse(text);
  function sanitize(node: JSONContent) {
    // Markdown image tokens bypass Image.parseHTML; never permit script/data URLs.
    if (node.type === "image" && !/^(https?:\/\/|\/(?!\/))/i.test(String(node.attrs?.src || ""))) {
      node.attrs = { ...node.attrs, src: "" };
    }
    node.marks?.forEach(mark => {
      if (mark.type === "textColor") mark.attrs = { color: normalizeTextColor(mark.attrs?.color) };
    });
    node.content?.forEach(sanitize);
  }
  sanitize(doc);
  return doc;
}

export function documentToText(doc: JSONContent): string {
  return markdown.serialize(doc);
}

export function textToEditorHtml(text: string): string {
  return text.trim() ? generateHTML(textToDocument(text), editorExtensions) : "";
}
